import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { fetchData, deleteData, activateData, fetchhistory, updateData, postData, fetchEngineerStockDetails } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import { Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';
import Modal from '@mui/material/Modal';
import { useHistory, useParams } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { FaTimes } from 'react-icons/fa';
import ReceiptIcon from '@mui/icons-material/Receipt';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import EditIcon from '@mui/icons-material/Edit';
import Select from 'react-select';
import { sendWhatsAppMessage } from './../../../apiService';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Update } from '@mui/icons-material';
import { TableContainer, Table, TableBody, TableRow, TableCell, Paper, Typography, TableHead } from '@mui/material';
import DataSaverOffIcon from '@mui/icons-material/DataSaverOff';

function EngineerWorkStatusIndex() {
    const [data, setData] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedSparepartss, setSelectedSparepartss] = useState("");
    const [formData, setFormData] = useState({});
    const [Remark, setRemark] = useState("");
    const [id, setId] = useState("");
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token, companyName } = useAuth();
    const [openModals, setOpenModal] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        // fetchData();
    }, [isAuthenticated, companyId, token, logout, userId]);

    const [datas, setDatas] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchEngineerStockDetails('ScheduleServiceApi', companyId, userId, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setDatas(response.response_data);
                    console.log(response);
                } else {
                    const responses = await fetchEngineerStockDetails('ScheduleServiceApi', companyId, userId, token);
                    if (responses.responseCode === '1111') {
                        setData(responses.response_data);
                    }
                }
            } catch (error) {
                console.error('Error occurred while fetching data:', error);
            }
        };

        fetchData();
    }, [companyId, userId, token]);


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [gridData, setGridData] = useState([]);
    // implementing the GST Concept


    const [selectedOption, setSelectedOption] = useState('product');
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);

    };


    //generate the Bill details 
    const [isSubmitDialogOpen, setSubmitDialogOpen] = useState(false);

    const tempstr = 0;
    const handleOpenSubmitDialog = (tempstr, requestID) => {
        setSubmitDialogOpen(true);
        handleGenerateBillstatus(tempstr, requestID);
    };

    // Final Bill
    const [billdata, setBillData] = useState([]);
    const [saleId, setSaleId] = useState(null); // State to hold the SaleID
    const handleGenerateBillstatus = (tempstr, requestID) => {
        // fetchData('InvoicedItemApi', `/${tempstr}/${requestID}`, token)
        fetchData('WorkStatusApi', `/${tempstr}/${requestID}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setBillData(response.response_data);

                    // Set the SaleID
                    const saleId = response.response_data[0].saleId; // Assuming there's only one SaleID in the response
                    setSaleId(saleId);
                    console.log(saleId);

                    const updatedInvoicedetailsSorted = response.response_data.reverse();
                    setBillData(updatedInvoicedetailsSorted);
                }
            })
            .catch((error) => {
                console.error('Error fetching Request Details:', error);
            });
    };

    useEffect(() => {
        const tempstr = '';
        const requestID = '';
        handleGenerateBillstatus(tempstr, requestID);
    }, []);


    const [formDatas, setFormDatas] = useState({
        //     PaymentType: 1 // Default to "Cash" (1)

    });

    //update the Billed Data 
    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const handleChange = (event) => {
        setSelectedPaymentType(event.target.value);
        setFormDatas((prevData) => ({
            ...prevData,
            IsPaymentMethod: event.target.value,
        }));
    };

    const toggleModal = () => {
        // setIsModalOpen(!isModalOpen);
        setSubmitDialogOpen(false);
    };

    // Pass the SaleID to updateRecord
    const updateRecord = (event) => {
        event.preventDefault();

        if (!saleId) {
            console.error('SaleID is missing');
            return;
        }

        const updatedFormData = {
            IsPaymentMethod: selectedPaymentType,
            ID: saleId, // Use the SaleID obtained from the state
            CompanyID: companyId,
            UpdatedBy: userId,
        };

        updateData('SaleEditApi', `${saleId}`, updatedFormData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);

                setTimeout(() => {
                    window.location.reload();
                }, 3000);
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };
    const invoiceDate = new Date(billdata[0]?.invoiceDate);

    // Format the date as dd/mm/yyyy
    const formattedDate = invoiceDate.toLocaleDateString('en-GB');


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '95%' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold' }}>ASSIGNED SERVICE'S</h6>

            </div>
            <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                {showSearchInput && (
                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        style={{ marginLeft: '10px', width: '200px' }}
                    />
                )}
            </div>
            <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>

                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '10%', textTransform: 'uppercase' }}>Work status</TableCell>
                                {/* <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize '16px', padding: '7px' }}>Sl.No</TableCell> */}
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '7%', textTransform: 'uppercase' }}>Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '15%', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '10%', textTransform: 'uppercase' }}>Contact</TableCell>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '15%', textTransform: 'uppercase' }}>Address</TableCell>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '9%', textTransform: 'uppercase' }}>Payment Mode</TableCell>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '15%', textTransform: 'uppercase' }}>Remarks</TableCell>
                                <TableCell sx={{ backgroundColor: '#f3f3f3', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', width: '14%', textTransform: 'uppercase' }}>Product</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {filteredData.map((item, index) => (
                                <TableRow key={item.Id} className="customTableRows">
                                    <TableCell sx={{ fontSize: '13px', width: '15%', padding: '1px' }}>
                                        {/* {(index + 1)} */}
                                        {item.workstatus !== 'Completed' && (
                                            <Link to={`/UpdateRequest/${item.requestID}`}>

                                                <Tooltip title="Info">
                                                    <IconButton>
                                                        <InfoIcon style={{ color: 'darkblue' }} />
                                                    </IconButton>
                                                </Tooltip>

                                            </Link>
                                        )}


                                        {item.workstatus === 'Completed' && !item.isBilled && (
                                            <Tooltip title="Bill Print">
                                                <IconButton onClick={() => handleOpenSubmitDialog(tempstr, item.requestID)}>

                                                    <DataSaverOffIcon style={{ color: 'darkmagenta' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        <p>{item.engineerWorkSS}</p>

                                    </TableCell>

                                    <TableCell sx={{ fontSize: '13px', width: '7%', padding: '1px' }}>
                                        {item.createdDate && new Date(item.createdDate).toLocaleDateString('en-GB')}
                                    </TableCell >
                                    <TableCell sx={{ fontSize: '13px', width: '15%', padding: '1px' }}>{item.customer}
                                        <p>({item.customertype})</p>
                                    </TableCell>
                                    <TableCell sx={{ fontSize: '13px', width: '10%', padding: '1px' }}>{item.number}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', width: '15%', padding: '1px' }}>{item.address}
                                        <p>({item.landmark},{item.pincode})</p> </TableCell>

                                    <TableCell sx={{ fontSize: '13px', width: '9%', padding: '1px' }}>{item.warranty}</TableCell>
                                    <TableCell sx={{ fontSize: '13px', width: '15%', padding: '1px' }}>{item.remarks}</TableCell>


                                    <TableCell sx={{ fontSize: '13px', width: '14%', padding: '1px' }}> <p>{item.serviceRequestTypes}-{item.product}({item.modal})</p></TableCell>
                                    {/* <TableCell sx={{ padding: '3px', fontSize: '14px' }}>{item.engineerWorkSS}</TableCell> */}

                                </TableRow>
                            ))}
                        </TableBody>

                    </Table>
                </TableContainer>


                {isSubmitDialogOpen && billdata.length > 0 && (
                    <div className="fixed top-0 inset-x-0 flex items-center justify-center z-1">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '99%', maxWidth: '800px' }}>
                            <div className="w-full mb-4 flex">
                                <div className="w-1/2 radio-group">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Payment Type
                                    </label>
                                    <div className="flex items-center">
                                        <label className="block uppercase tracking-wide text-gray-700  font-bold mr-2">
                                            <input
                                                type="radio"
                                                name="PaymentType"
                                                value="1"
                                                checked={selectedPaymentType === "1"}
                                                onChange={handleChange}
                                            />
                                            Cash
                                        </label>
                                        <label className="block uppercase tracking-wide text-gray-700  font-bold mr-2">
                                            <input
                                                type="radio"
                                                name="PaymentType"
                                                value="2"
                                                checked={selectedPaymentType === "2"}
                                                onChange={handleChange}
                                            />
                                            Credit
                                        </label>
                                        <label className='block uppercase tracking-wide text-gray-700  font-bold'>
                                            <input
                                                type="radio"
                                                name="PaymentType"
                                                value="3"
                                                checked={selectedPaymentType === "3"}
                                                onChange={handleChange}
                                            />
                                            UPI
                                        </label>

                                        {billdata[0].warranty === "Warranty" && (
                                            <label className='block uppercase tracking-wide text-gray-700 font-bold' style={{ marginLeft: '10px' }}>
                                                <input
                                                    type="radio"
                                                    name="PaymentType"
                                                    value="4"
                                                    checked={selectedPaymentType === "4"}
                                                    onChange={handleChange}
                                                />
                                                WTY
                                            </label>
                                        )}
                                        {billdata[0].warranty === "AMC" && (
                                            <label className='block uppercase tracking-wide text-gray-700 font-bold' style={{ marginLeft: '10px' }}>
                                                <input
                                                    type="radio"
                                                    name="PaymentType"
                                                    value="5"
                                                    checked={selectedPaymentType === "5"}
                                                    onChange={handleChange}
                                                />
                                                AMC
                                            </label>
                                        )}
                                    </div>
                                </div>
                                <div className="w-1/2 flex justify-end">
                                    <button className="bg-green-500 text-white px-2 py-1 rounded" style={{ height: '30px' }} onClick={updateRecord}>
                                        Save
                                    </button>
                                    <button className="bg-blue-500 text-white px-2 py-1 rounded ml-2" style={{ height: '30px' }} onClick={toggleModal}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                            <div className="text-center mb-4" style={{ color: 'brown', fontWeight: 'bolder', marginTop: '-15px', fontSize: '18px' }}>
                                INVOICE
                            </div>
                            <div className="flex mb-2 items-start justify-between">
                                <div>
                                    <p style={{ marginTop: '-15px' }}><strong style={{ color: 'blueviolet' }}>{billdata[0]?.customer}</strong></p>
                                    <p style={{ color: 'black', marginTop: '-15px' }}>Warranty :<strong>{billdata[0]?.warranty}</strong></p>
                                    <p style={{ color: 'black', marginTop: '-15px' }}>Bill No :<strong>{billdata[0]?.invoiceNo}</strong></p>
                                    <p style={{ color: 'black', marginTop: '-15px' }}>Date : <strong>{formattedDate}</strong></p>
                                </div>
                                <div className="w-1/2 ml-auto mr-2">
                                    <p style={{ color: 'black', marginTop: '-15px', textAlign: 'right' }}>T.Amount :<strong>{billdata[0]?.netAmount.toFixed(2)}</strong></p>
                                    <p style={{ color: 'black', marginTop: '-15px', textAlign: 'right' }}>T.CGST :<strong>{billdata[0]?.cgstAmount.toFixed(2)}</strong></p>
                                    <p style={{ color: 'black', marginTop: '-15px', textAlign: 'right' }}>T.SGST : <strong>{billdata[0]?.sgstAmount.toFixed(2)}</strong></p>
                                    <p style={{ color: 'black', marginTop: '-15px', textAlign: 'right' }}>Net.Amt : <strong>₹{billdata[0]?.totalAmount.toFixed(2)}</strong></p>
                                </div>
                            </div>
                            <div className='w-full mb-5 flex' style={{ maxHeight: '300px', maxWidth: '900px', overflowY: 'auto' }}>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                            <TableRow>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Sl.no</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd' }}>Item Name</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Rate</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>GST%</TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #ddd', textAlign: 'center' }}>Quantity</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {billdata.map((item, index) => (
                                                <TableRow key={item.Id}>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '10px', padding: '10px' }}>{index + 1}</TableCell>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '650px', padding: '10px' }}>{item.spareparts}</TableCell>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '150px', padding: '10px', textAlign: 'center' }}>{item.salerate}</TableCell>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '150px', padding: '10px', textAlign: 'center' }}>
                                                        {item.gstrate ? `${item.gstrate}%` : '0 (%)'}
                                                    </TableCell>
                                                    <TableCell className="customTableCell" sx={{ height: '40px', width: '150px', padding: '10px', textAlign: 'center' }}>{item.quantity}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </div>
                    </div>
                )}
            </div >
        </div >
    );
}

export default EngineerWorkStatusIndex;